import { TheMask } from 'vue-the-mask'

export default {
  TheMask
}



// WEBPACK FOOTER //
// ./src/app/tenant/car/resources/components.js